import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import Modal from '@deliveroo/consumer-component-library/components/Modal';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import i18n from '../../utils/i18n';

import SocialButton from '../SocialButton';
import ReferralCodeInput from '../ReferralCodeInput';
import styles from './InviteModal.scss';

export default class InviteModal extends React.Component {
  componentDidMount() {
    const { isOpen } = this.props;

    if (isOpen) {
      this.trackModalShown();
    }
  }

  componentDidUpdate() {
    const { isOpen } = this.props;

    if (isOpen) {
      this.trackModalShown();
    }
  }

  onShareEvent = (type) => () => {
    const { trackInviteSent } = this.props;

    trackInviteSent(type);
  };

  trackModalShown = () => {
    const { trackInviteModalShown, referralCode, inviteeAmount, referrerAmount } = this.props;

    trackInviteModalShown({
      promptContext: 'landing page',
      referralCode,
      inviteeAmount,
      referrerAmount,
    });
  };

  render() {
    const {
      appElement,
      isOpen,
      onClose,
      headerTitle,
      bodyHeading,
      bodyText,
      inviteLinkDescription,
      referralHref,
      referralLink,
      copyLabel,
      copiedLabel,
      shareTextEmailSubject,
      shareTextEmailBody,
      shareTextTwitter,
      shareTextFacebook,
    } = this.props;

    return (
      <Modal
        appElement={appElement}
        type="fullscreen"
        isOpen={isOpen}
        onClose={onClose}
        closeButtonLabel={i18n.gettext('closeButton.label')}
        headerTitle={headerTitle}
      >
        <div className={styles.fistBump} />
        <div className={styles.header}>
          <Heading level={2} size="x-small" spacing="large 0 0 0">
            {bodyHeading}
          </Heading>
          <P color="grey" adjacentVerticalSpacing="small">
            {bodyText}
          </P>
        </div>
        <ReferralCodeInput
          label={inviteLinkDescription}
          displayValue={referralLink}
          copyValue={referralHref}
          copyLabel={copyLabel}
          copiedLabel={copiedLabel}
          adjacentVerticalSpacing="x-large"
          onCopyClick={this.onShareEvent('copy-link')}
        />
        <Spacer adjacentVerticalSpacing="medium">
          <div className={styles.socialSharingButtons}>
            <EmailShareButton
              url={referralHref}
              subject={shareTextEmailSubject}
              body={shareTextEmailBody}
              className={styles.shareButton}
            >
              <SocialButton type="email" onClick={this.onShareEvent('email')} isBlock />
            </EmailShareButton>
            <FacebookShareButton
              url={referralHref}
              quote={shareTextFacebook}
              className={styles.shareButton}
              tabindex={null}
            >
              <SocialButton type="facebook" onClick={this.onShareEvent('facebook')} isBlock />
            </FacebookShareButton>
            <TwitterShareButton
              url={referralHref}
              title={shareTextTwitter}
              className={styles.shareButton}
              tabindex={null}
            >
              <SocialButton type="twitter" onClick={this.onShareEvent('twitter')} isBlock />
            </TwitterShareButton>
          </div>
        </Spacer>
      </Modal>
    );
  }
}

InviteModal.defaultProps = {
  appElement: '#__next',
  referralHref: '',
  referralLink: '',
  referralCode: '',
  referrerAmount: '',
  inviteeAmount: '',
};

InviteModal.propTypes = {
  appElement: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  headerTitle: PropTypes.string.isRequired,
  bodyHeading: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  inviteLinkDescription: PropTypes.string.isRequired,
  referralHref: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referralLink: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referralCode: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referrerAmount: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  inviteeAmount: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  copyLabel: PropTypes.string.isRequired,
  copiedLabel: PropTypes.string.isRequired,
  shareTextEmailSubject: PropTypes.string.isRequired,
  shareTextEmailBody: PropTypes.string.isRequired,
  shareTextTwitter: PropTypes.string.isRequired,
  shareTextFacebook: PropTypes.string.isRequired,
  trackInviteSent: PropTypes.func.isRequired,
  trackInviteModalShown: PropTypes.func.isRequired,
};
